import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import ShowInvoiceDetails from '../components/ShowInvoiceDetails';
import "../App.css"
import { RootState } from '../store/store';
import { useTranslation } from 'react-i18next';
import { Invoice } from '../types/invoiceForm';
import { Offer } from '../types/offerForm';
import { useLocation } from 'react-router-dom';
import ShowOfferDetails from '../components/ShowOfferDetails';



const DocumentDetails = () => {
  const { t } = useTranslation();  
  const { id } = useParams();
  const [document, setDocument] = useState<Invoice | Offer>()
  const location = useLocation();
  const { type } = location.state || {};
  const invoices = useSelector((state: RootState) => state.invoices as Invoice[])
  const offers = useSelector((state: RootState) => state.offers as Offer[])
  
  useEffect(() => {
    if(id){
      if(type === 'invoice'){
        const targetInvoice = invoices.find((invoice: Invoice) => invoice?.id === parseInt(id));
        if (targetInvoice) {
          setDocument(targetInvoice)
        }      
      }
      if(type === 'offer'){
        const targetOffer = offers.find((offer: Offer) => offer?.id === parseInt(id));
        if (targetOffer) {
          setDocument(targetOffer);
        }
      }
    }    
  }, [offers, invoices, id, type])

  return (
    <div className="container">
      <div className='mb-5'>
        <Link to="/">
          <Button variant="outline-primary" size="sm">
            {t('backHome')}
          </Button>
        </Link>{' '}
        <Link to={`/edit/${id}`} state={{type: type}}>
          <Button variant="outline-dark" size="sm">
          {type === 'invoice' ? t('editInvoice') : t('editOffer')}
          </Button>
        </Link>{' '}
      </div>
      {document ?
        type === 'invoice'?
        (<ShowInvoiceDetails invoice={document as Invoice} />):(<ShowOfferDetails offer={document as Offer}></ShowOfferDetails>)
        :
        <div>
          <h1> {t('message.noInvoiceWithId')}: {id}</h1>
          <h2>{t('message.newInvoiceCreation')}
            <Link to="/create"> {t('link.here')}.</Link>
          </h2>
        </div>
      }
    </div>
  )
}

export default DocumentDetails